<template>
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.6549 4.16664H3.3334V2.49997H12.6667C13.127 2.49997 13.5001 2.87307 13.5001 3.3333V12.6666H11.8334V5.34515L3.92265 13.2559L2.74414 12.0774L10.6549 4.16664Z"
    />
  </svg>
</template>
